import { IChannel } from "src/app/channel/~store/models/Channel";
import { IContact } from "../models/Contact";
import { IMessenger } from "../models/Messenger";
import {IContactState} from "./ContactState";

export const initNewContact = (): IContact => {
    return {
        contactId: 0,
        createdOn: new Date(),
        avatarId: null,
        firstName: '',
        lastName: '',
        nickName: '',
        patronymic: '',
        externalId: '',
        chatName: '',
        phone: '',
        messengers: [],
        chatsCount: 0,
        accounts: [],
        contactComment: '',
        isDeleted: false,
        locale: '',
        tags: []
    }
}


export const initNewMessenger = (contact: IContact, channel: IChannel): IMessenger => {
    return {
        messengerId: 0,
        externalId: '',
        nickName: '',
        avatarId: null,
        channelId: channel.channelId,
        channelModel: channel
    }
}

export const initState: IContactState = {
    contactList: {
        contacts: [],
        suggestionContacts: [],
        allChannels: [],
        isReceivingContacts: false,
        isContactCreating: false,
        countOfContacts: 0,
        searchString: '',
        tags: [],
        isSortingByContactLastName: false,
        contactItemInfo: {
            selectedContact: initNewContact(),
            changedContact: initNewContact(),
            contactToMerge: initNewContact(),
            isReceivingContact: false,
            isRestoringContact: false,
        },
        accountTypes: []
    }
}